import React from 'react'
import { getMainQuestion } from '../utils'
import { RenderQuestionBlock } from './RenderQuestionBlock'
import { PaperBlock } from 'packages/sdks-next/growp'

export const QuestionBlock: React.FC<{
  block: PaperBlock
}> = ({ block }) => {
  const mainQuestion = getMainQuestion(block.questions || [])
  if (!mainQuestion) return null
  return (
    <RenderQuestionBlock
      mainQuestion={mainQuestion}
      block={block}
    />
  )
}
